import {Injectable} from '@angular/core';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {Observable} from 'rxjs';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {UmpirePlayer} from '@tisa-group/models';

@Injectable()
export class PlayerService implements CrudService<UmpirePlayer> {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpirePlayer[]>> {
    return this.http
      .get('/players', {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpirePlayer>> {
    return this.http
      .get(`/players/${fetchIdentifier}`, {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`/players/${id}`);
  }

  create(
    body: Partial<UmpirePlayer>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpirePlayer>> {
    return this.http.post<JsonApiResponse<UmpirePlayer>>(
      '/players',
      serialize({stuff: body}),
      {
        params: objectToHttpParams(params),
      },
    );
  }

  update(
    body: Partial<UmpirePlayer>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpirePlayer>> {
    return this.http
      .patch<JsonApiResponse<UmpirePlayer>>(
        `/players/${body.id}`,
        serialize({stuff: body}),
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }
}
